import React, { useEffect, useState, Fragment } from 'react';
function useCountdown(initialSeconds: number) {
  const [remaining, setRemaining] = useState(initialSeconds);
  useEffect(() => {
    const id = setInterval(() => {
      setRemaining(s => s > 0 ? s - 1 : 0);
    }, 1000);
    return () => clearInterval(id);
  }, []);
  const hrs = Math.floor(remaining / 3600);
  const mins = Math.floor(remaining % 3600 / 60);
  const secs = remaining % 60;
  return {
    hrs,
    mins,
    secs
  };
}
const pad = (n: number) => n.toString().padStart(2, '0');
type Props = {
  variant?: 'light' | 'dark';
};
export function Countdown({
  variant = 'light'
}: Props) {
  // 23h 53m 06s
  const {
    hrs,
    mins,
    secs
  } = useCountdown(23 * 3600 + 53 * 60 + 6);
  const box = variant === 'dark' ? 'bg-white/15 text-white border-white/20' : 'bg-navy text-white border-navy';
  const unit = variant === 'dark' ? 'text-white/70' : 'text-navy/60';
  const blocks: Array<[string, string]> = [[pad(hrs), 'HS'], [pad(mins), 'MIN'], [pad(secs), 'SEG']];
  return <div className="flex items-stretch justify-center gap-2 sm:gap-3" data-id="element-54" data-mp="xzc0rxymghno">
      {blocks.map(([value, unitLabel], i) => <Fragment key={unitLabel} data-id="element-55" data-mp="t092qxh27bp7" data-mpi={i}>
          <div className="flex flex-col items-center" data-id="element-56" data-mp="17r9bl3lpx7lv">
            <div className={`flex min-w-[64px] items-center justify-center rounded-xl border px-3 py-2.5 font-display text-3xl font-black tabular-nums shadow-card sm:min-w-[80px] sm:text-4xl ${box}`} data-id="element-57" data-mp="17sst0xj41op8">
              {value}
            </div>
            <span className={`mt-1.5 text-[10px] font-bold uppercase tracking-widest sm:text-xs ${unit}`} data-id="element-58" data-mp="a4iy12hqs17m">
              {unitLabel}
            </span>
          </div>
          {i < blocks.length - 1 && <span className={`self-start pt-1 font-display text-3xl font-black sm:text-4xl ${variant === 'dark' ? 'text-white/50' : 'text-magenta'}`} data-id="element-59" data-mp="k3rqfqwyl7rv">
              :
            </span>}
        </Fragment>)}
    </div>;
}